import * as angular from "angular";
import {applyMiddleware, createStore} from "redux";
import {default as reducers} from "../reducers";
import thunk from "redux-thunk";
import * as React from "react";
import {connect, Provider} from "react-redux";
import server from "../../../../integration/server/server-services";
import nvdbapi from "../../../../integration/nvdbapi/nvdbapi";
import security from "../../../../service/security/security-services";
import {
    getRoadObjects,
    GetRoadObjects,
    getRoadObjectTypeList,
    GetRoadObjectTypeList,
    InitLocational,
    initLocational
} from "../actions";
import LocationalState from "../LocationalState";
import {TypeList} from "./TypeList";
import {LocationalMap} from "./LocationalMap";
import {LocationalToolBox} from "./LocationalToolBox";
import {ProgressOverlay} from "./ProgressOverlay";
import {ConfidenceFilters} from "./ConfidenceFilters";
import {AutolocalizeTool} from "./AutolocalizeTool";
import {LocationalBackedToggle} from "./LocationalBackendToggle";
import datacatalog from "../../../../integration/datacatalog/datacatalog-services";

export class ServerHolder {
    constructor(
        public security: security = null,
        public server: server = null,
        public scope: angular.IRootScopeService = null,
        public nvdbapi: nvdbapi = null,
        public datacatalog: datacatalog = null,
        public $q: angular.IQService = null,
        public contractId: string = null,
    ) {
    }
}

const serverHolder = new ServerHolder();
const store = createStore(reducers, applyMiddleware(thunk.withExtraArgument(serverHolder)));

interface LocationalProps {
    server: server,
    security: security,
    nvdbapi: nvdbapi,
    datacatalog: datacatalog,
    $q: angular.IQService,
    $routeParams: angular.route.IRouteParamsService,
    $rootScope: angular.IRootScopeService
}

interface StateProps {
    contractId: string,

}

interface DispatchProps {
    doInitLocational: InitLocational,
    doGetRoadObjectTypeList: GetRoadObjectTypeList,
    doGetRoadObjects: GetRoadObjects,
}

interface TagProps {
}

interface localState {
    isLoggedIn: boolean,
}

type Props = DispatchProps & StateProps & TagProps;

class LocationalView extends React.Component<Props, localState> {


    componentDidMount() {
        let {contractId} = this.props;
        this.props.doInitLocational();
        this.props.doGetRoadObjectTypeList(contractId);
        this.props.doGetRoadObjects(contractId);
    }

    render() {
        let {contractId} = this.props;


        return (
            <>
                <ProgressOverlay/>
                <div id="locational-view">
                    <div>
                        <div className={"locational-types"}>
                            <div className={"locational-tools"}>
                                <AutolocalizeTool  />
                                <ConfidenceFilters />
                            </div>
                            <TypeList/>
                            <LocationalBackedToggle/>
                        </div>
                        <div className={"locational-map-container"}>
                            <LocationalMap/>
                            <LocationalToolBox/>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}


export class Locational2 extends React.Component<LocationalProps, {isLoggedIn: boolean}> {

    constructor(props: LocationalProps) {
        super(props);
        this.state = {
            isLoggedIn: false
        }
    }

    componentDidMount() {
        this.props.security.ensureCurrentUser().then(result => {
            this.setState(
                {
                    isLoggedIn: true,
                })
        })
    }

    render() {
        const mapStateToProps = (state: LocationalState): StateProps => {
            const contractId = this.props.$routeParams["contractId"];
            return {
                contractId: contractId,
            }
        };

        const mapDispatchToProps: DispatchProps = ({
            doInitLocational: initLocational,
            doGetRoadObjectTypeList: getRoadObjectTypeList,
            doGetRoadObjects: getRoadObjects,
        });

        serverHolder.security = this.props.security;
        serverHolder.server = this.props.server;
        serverHolder.nvdbapi = this.props.nvdbapi;
        serverHolder.datacatalog = this.props.datacatalog;
        serverHolder.$q = this.props.$q;
        serverHolder.contractId = this.props.$routeParams["contractId"];
        serverHolder.scope = this.props.$rootScope;

        const LocationalComponent = connect(mapStateToProps, mapDispatchToProps)(LocationalView);

        // prevent mounting LocationalComponent if the user is not logged in.
        // this keeps the login-window clean and we ensure that the user is logged in before we query the API on mount.
        if (!this.state.isLoggedIn) {
            return null;
        }

        return (
            <Provider store={store} key="provider">
                <LocationalComponent/>
            </Provider>
        )
    }
}

